// extracted by mini-css-extract-plugin
export var indeterminate = "_48-6";
export var md = "_48-5";
export var semantic = "_48-7";
export var sm = "_48-4";
export var text = "_48-8";
export var toggleControl = "_48-0";
export var toggleInput = "_48-1";
export var toggleSwitch = "_48-2";
export var xs = "_48-3";